import type { FaireProductEntity } from "../../entity_types/product";

export const p_ju9vtwseef: FaireProductEntity = {
  token: "p_ju9vtwseef",
  type: "product",
  name: "Blue Bow Little Notes® Duo Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6b759969524be2c0e251805e0feecd45bacc36cdc68bbdaab43efb62148f461d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/79fe25ce9de05d71cee4206d59ea29974bd1309ecc5c4dc9d1a0ab2ef4b3ee52.jpeg",
    "https://cdn.faire.com/fastly/6178d1110cc414b390e512c4cf75e6bf5683cd6e042047c6a295801b3989f215.jpeg",
    "https://cdn.faire.com/fastly/4c7ce66f1b886ea1be4ffb74650154f400f5f855f44e8cc567a8e325eaf1193f.jpeg",
    "https://cdn.faire.com/fastly/f2d8fd76d0444a648d663e700e0a17e825ef2cebdf4125d75018958226956076.jpeg",
  ],
  priceDollars: 6,
  description:
    "The cutest little duos you ever did see. Set of 10 Little Notes®and 10 Little Note Envelopes. These corresponding Little Notes® and printed envelopes take the surprise and delight of Little Notes to the next level - so up your gift tag/secret note/barista tip game! Please note: These envelopes are so adorably tiny that they're too small for the postal service, so hand-deliver only!",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:58.135Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
